import c from 'classnames';
import { TextLink, Typography } from 'components';

import styles from './GenericCardWithImage.module.scss';

export interface GenericCardWithImageProps {
  title: string;
  section?: string;
  image?: string;
  expandVertically?: boolean;
  link?: string;
  cta?: string;
  external?: boolean;
  overlay?: React.ReactNode;
  children?: React.ReactNode;
}

const GenericCardWithImage: React.FC<GenericCardWithImageProps> = ({
  title,
  section,
  link,
  cta,
  image,
  expandVertically = false,
  external = false,
  overlay,
  children,
}) => {
  return (
    <div
      className={c(
        styles.cardContainer,
        expandVertically && styles.verticalExpand,
      )}
    >
      <div className={c(styles.cardContent, !image && styles.noImage)}>
        <div className={styles.cardTextContainer}>
          {!!section && (
            <Typography variant={'label'} medium>
              {section}
            </Typography>
          )}
          {!!title && (
            <Typography variant={'heading-l'} medium>
              {title}
            </Typography>
          )}
        </div>
        {children}
        {!!link && !!cta && (
          <TextLink
            label={cta}
            to={link}
            external={external}
            iconNameRight='chevronForward'
          />
        )}
      </div>
      {image && (
        <div className={styles.imageContainer}>
          <img src={image} alt='Illustration' />
          {!!overlay && <div className={styles.overlay}>{overlay}</div>}
        </div>
      )}
    </div>
  );
};

export default GenericCardWithImage;
